var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8594 7.0625C16.4531 7.65625 16.4531 8.625 15.8594 9.1875L9.48438 15.5625C8.92188 16.1562 7.95312 16.1562 7.35938 15.5625L0.765625 8.96875C0.484375 8.6875 0.328125 8.3125 0.328125 7.90625V1.5C0.328125 0.6875 0.984375 0 1.82812 0H8.20312C8.60938 0 8.98438 0.1875 9.26562 0.46875L15.8594 7.0625ZM15.1719 8.5C15.3594 8.28125 15.3594 7.96875 15.1719 7.78125L8.54688 1.15625C8.45312 1.0625 8.32812 1 8.20312 1H1.82812C1.54688 1 1.32812 1.25 1.32812 1.5V7.90625H1.29688C1.29688 8.03125 1.35938 8.15625 1.45312 8.25L8.07812 14.875C8.26562 15.0625 8.57812 15.0625 8.79688 14.875L15.1719 8.5ZM4.82812 3.875C4.45312 3.875 4.20312 4.15625 4.20312 4.5C4.20312 4.875 4.45312 5.125 4.82812 5.125C5.17188 5.125 5.45312 4.875 5.45312 4.5C5.45312 4.15625 5.17188 3.875 4.82812 3.875ZM4.82812 3C5.64062 3 6.32812 3.6875 6.32812 4.5C6.32812 5.34375 5.64062 6 4.82812 6C3.98438 6 3.32812 5.34375 3.32812 4.5C3.32812 3.6875 3.98438 3 4.82812 3Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.28042bf34a5d07309b8eeda7ea040799.svg";
export { ForwardRef as ReactComponent };